export enum Variant {
  PRIMARY = "primary",
  WARNING = "warning",
  SUCCESS = "success",
  DANGER = "danger",
}
